export default __webpack_public_path__ + "static/badge_eagle-8324be8b99cb0497a1736505f749443c.png";